import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import { Controller } from 'react-hook-form';
import moment from 'moment';
import InputTextAcessibilidade from 'components/InputAcessibilidade';
import * as S from './styles';
import * as Style from 'components/Style';

const dateFormat = 'DD/MM/YYYY';

export const InputDate = ({
  label,
  errors,
  name,
  control,
  onChange,
  disabled,
  isClear,
  value,
  defaultValue = null,
  disabledDate,
  inputReadOnly = true,
}) => {
  const getOnlyDate = change => {
    const valorInput = {
      target: { name: name, value: change?._d || null },
    };
    onChange(valorInput);
    return change;
  };

  const getValue = () => {
    if (isClear) return null;

    const dateMomentFormat = defaultValue && moment(defaultValue?.toString(), dateFormat);
    const dateMoment = defaultValue && moment(defaultValue?.toString());
    const dateValue = value;

    if (dateMomentFormat?._isValid) return dateMomentFormat;
    if (dateMoment?._isValid) return dateMoment;
    return dateValue;
  };

  return (
    <S.InputContain id="ComponenteDataPicker">
      {label && <S.Label>{label}</S.Label>}
      <Controller
        name={name}
        control={control}
        render={() => {
          return (
            <>
              {disabled ? (
                <InputTextAcessibilidade value={getValue()?._i || getValue()} />
              ) : (
                <DatePicker
                  name={name}
                  disabled={disabled}
                  onChange={change => getOnlyDate(change)}
                  value={getValue()}
                  defaultValue={getValue()}
                  format={dateFormat}
                  data-testid="input Data Picker"
                  inputReadOnly={inputReadOnly}
                  autoclose={true}
                  disabledDate={disabledDate}
                />
              )}
              {errors && errors[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
            </>
          );
        }}
      />
    </S.InputContain>
  );
};

InputDate.propTypes = {
  label: PropTypes.string,
  errors: PropTypes.object,
  name: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isClear: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.object,
  disabledDate: PropTypes.func,
  inputReadOnly: PropTypes.bool,
};

InputDate.defaultProps = {};

export default InputDate;
